import React, { useEffect, useState } from 'react';
import { AuthProvider } from './context/AuthContext';
import { ConfigProvider } from './context/ConfigContext';
import { PortalProvider } from './context/PortalContext';
import { ToastProvider } from './context/ToastContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import OfficerDashboard from './components/OfficerDashboard/OfficerDashboard';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import ToastViewport from './components/Toast/ToastViewport';
import './App.module.css';

function AppShell() {
  const { theme } = useTheme();
  const dataTheme = theme !== 'system' ? theme : undefined;

  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const [authState, setAuthState] = useState(null);

  useEffect(() => {
    // Fetch auth state from admin-ajax.php — never served by page caches.
    // This is the only reliable source of truth when the page HTML may be
    // a cached copy with stale window.LEP baked into it.
    const apiBase = window.LEP?.api_base || '/wp-admin/admin-ajax.php';
    fetch(`${apiBase}?action=lep_get_auth_state`, { credentials: 'same-origin' })
      .then(r => r.json())
      .then(data => {
        if (data.success && data.data?.authenticated) {
          setAuthState(data.data);
          setIsLoading(false);
        } else {
          // Not authenticated — reload so PHP can render the login form.
          window.location.reload();
        }
      })
      .catch(() => {
        setHasError(true);
        setIsLoading(false);
      });
  }, []);


  if (isLoading) {
    return (
      <div data-theme={dataTheme} className="lep-loading">
        <div className="lep-spinner" />
        Loading portal...
      </div>
    );
  }

  if (hasError) {
    return (
      <div data-theme={dataTheme} className="lep-error">
        <p>Not authenticated. Please log in first.</p>
      </div>
    );
  }

  return (
    <div data-theme={dataTheme} className="lep-app-root">
      <ErrorBoundary>
        <ToastProvider>
          <ConfigProvider>
            <AuthProvider authState={authState}>
              <PortalProvider>
                <OfficerDashboard />
                <ToastViewport />
              </PortalProvider>
            </AuthProvider>
          </ConfigProvider>
        </ToastProvider>
      </ErrorBoundary>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppShell />
    </ThemeProvider>
  );
}

export default App;
